module.exports = __webpack_public_path__ + "static/media/penguin.5c4ec0ca.png";